<template>
  <v-carousel
    hide-delimiters
    cycle
    :height="carouselHeight"
    show-arrows-on-hover
    hide-delimiter-background
  >
    <v-carousel-item
      v-for="(item, index) in carouselItems"
      :key="index"
      reverse-transition="fade-transition"
      transition="fade-transition"
    >
      <v-img :src="item.image" alt="Banner Image" contain></v-img>
    </v-carousel-item>
  </v-carousel>
</template>
  
  <script>
export default {
  data() {
    return {
      carouselItems: [
        { image: "../assets/img_sample/banner1.png" },
        { image: "../assets/img_sample/banner2.png" },
      ],
    };
  },
  computed: {
    carouselHeight() {
      if (this.$vuetify.breakpoint.xs) {
        return 140; // Set the height for xs breakpoint
      } else if (this.$vuetify.breakpoint.sm) {
        return 220; // Set the height for sm breakpoint
      } else if (this.$vuetify.breakpoint.md) {
        return 310; // Set the height for md breakpoint// Set the height for lg breakpoint
      } else if (this.$vuetify.breakpoint.lg) {
        return 400; // Set the height for md breakpoint// Set the height for lg breakpoint
      } else {
        return 600; // Set the height for xl breakpoint
      }
    },
  },
};
</script>
  